import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Reserve } from 'src/models/reserve.model';
import { Testimonial } from 'src/models/testimonial.model';
import { TestimonialsService } from 'src/services/testimonials.service';
import { ReserveService } from 'src/services/reserve.service';

 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'TatvaApp';

  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
 
  reserveResponse: string = '';
  testimonialsResponse: string = '';
  reserve:Reserve;
  testimonial:Testimonial;
  SiteKey:string="6Leum_YUAAAAAMSgsbl3EEs90b5dkKuZU_2syoDt";
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title, private formBuilder: FormBuilder, 
    private testimonialService:TestimonialsService,
    private reserveService:ReserveService) {
    this.reserve=new Reserve();
    this.testimonial=new Testimonial();

    localStorage.setItem("SiteKey",this.SiteKey);
  }
 
  ngOnInit() {
    this.GetWhatsappNos();
    const appTitle = this.titleService.getTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;   
          //child.snapshot.routeConfig["path"]
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });

  }
  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }
  
  color : any;
  pagitionfirst : boolean = false;
  pagitionsecond : boolean = false;
  paginationthird : boolean = false;
  getPaginationfirst(){
    this.color ='active';
    this.pagitionsecond = false;
    this.paginationthird = false;
    this.pagitionfirst = true;
  }
  getPaginationsecond(){   
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.pagitionsecond = true;
  }
  getPaginationthird(){ 
    this.pagitionfirst = false;
    this.paginationthird = true;
    this.pagitionsecond = false;
  }
  disabledbutton : boolean = false;
  getPaginationnext(){
    if(this.pagitionfirst == true){
      this.getPaginationsecond();
    }
    else if(this.pagitionsecond == true){
      this.getPaginationthird();
    }
    else{
      this.disabledbutton= true;
    }
  }

  
  ReserveCaptchaResponse(captchaResponse: string) {
    this.reserve.Captcha='';
    this.reserve.Captcha = captchaResponse;
    console.log(`Resolved response token: ${captchaResponse}`);
  } 


  onReserveSubmit(formData) {

    this.reserveResponse = '';

    if (!this.reserve.Name)
    {
      this.reserveResponse = "Enter The Name.";
      return;
    }
    if (!this.reserve.Email)
    {
      this.reserveResponse = "Enter The Email.";
      return;
    }
    if (!this.reserve.PhoneNo) {
      this.reserveResponse = "Enter The Phone No.";
      return;
    }
    if (!this.reserve.Member) {
      this.reserveResponse = "Select No. Of Memeber.";
      return;
    }
    
    debugger;
    this.reserve.VisitingDate = new Date((document.getElementById("datepicker") as HTMLInputElement).value);
    this.reserve.VisitingDate = new Date((document.getElementById("datepicker2") as HTMLInputElement).value);
    
    if (!this.reserve.VisitingDate)
    {
      this.reserveResponse += "Select visiting Date";
      return;
    }
   

    // if (!formData.visitingDate)
    //   this.reserveResponse += "Select visiting Date";

    if (!this.reserve.VisitingTime) {
      this.reserveResponse = "Select Visiting Time";
      return;
    }
    if (!this.reserve.Message) {
      this.reserveResponse = "Enter The Message";
      return;
    }

    if (!this.reserve.Captcha) {
      this.reserveResponse = "Please verify you are human!";
      return;
    }

    this.reserveService.Save(this.reserve).subscribe(
      data => {

        var result = data;
        console.log(data);
        grecaptcha.reset(1);
        this.reserveResponse ="Your request has been submitted. Our executive will call you soon.";
        this.reserve =new Reserve();
        
      },
      error => {        
        console.log(error);
      }
    );

       
    // alert("Name : " + formData.name + "\nEmail : " + formData.email + "\nPhone No : " + formData.phone+"\nMemeber : "+
    // formData.member+"\nVisiting Date : "+formData.visitingDate + "\nVisiting Time : " + formData.visitingTime+"\nmessage: " + formData.message);
  }

  TestimonialCaptchaResponse(captchaResponse: string) {
    this.testimonial.Captcha='';
    this.testimonial.Captcha = captchaResponse;
    console.log(`Resolved response token: ${captchaResponse}`);
  }

  
  onTestimonialSubmit(testimonialData) {
    this.testimonialsResponse = '';

    if (!this.testimonial.Name)
    {
      this.testimonialsResponse = "Please enter the name";
      return;
    }
    if (!this.testimonial.Email)
    {
      this.testimonialsResponse = "Please enter the email";
      return;
    }
    if (!this.testimonial.PhoneNo) {
      this.testimonialsResponse = "Please enter the phone number";
      return;
    }
    if (this.testimonial.PhoneNo.length != 10) {
      this.testimonialsResponse = "Please enter valid phone number";
      return;
    }
    // this.testimonial.VisitingDate = new Date((document.getElementById("datepicker1") as HTMLInputElement).value);
    
    if (!this.testimonial.VisitingDate)
    {
      this.testimonialsResponse = "Please select visiting date";
      return;
    }
   
    if (!this.testimonial.Message) {
      this.testimonialsResponse = "Please enter the message";
      return;
    }

    if (!this.testimonial.Captcha) {
      this.testimonialsResponse = "Please verify you are human";
      return;
    }
    if(!this.validateEmail()){
      this.testimonialsResponse = "Please email address is invalid";
      return;
    }
    this.testimonialService.Save(this.testimonial).subscribe(
      data => {

        var result = data;
        console.log(data);
        grecaptcha.reset(1);
        this.testimonialsResponse ="Your request has been submitted. Our executive will call you soon.";
        this.testimonial =new Testimonial();
        
      },
      error => {        
        console.log(error);
      }
    );

        
    //alert("Name : " + formData.name + "\nEmail : " + formData.email + "\nPhone No : " + formData.phone+"\nMemeber : "+
    // formData.member+"\nVisiting Date : "+formData.visitingDate + "\nVisiting Time : " + formData.visitingTime+"\nmessage: " + formData.message);
  }


  DateChange()
  {
    alert('Welcome');
  }

validateEmail(){  
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.testimonial.Email).toLowerCase());    
   }


  // UploadBulkScheme() {
  //   if (this.ValidateForm()) {

  //     console.log('Start: ' + this.SchemeModel.StartMonth + ' ' + this.SchemeModel.StartYear +
  //       ' End:' + this.SchemeModel.EndMonth + ' ' + this.SchemeModel.EndYear +
  //       ' Branch: ' + this.SchemeModel.Branch);

  //     const formData = new FormData();

  //     formData.append("StartMonth", this.SchemeModel.StartMonth.toString());
  //     formData.append("StartYear", this.SchemeModel.StartYear.toString());
  //     formData.append("EndMonth", this.SchemeModel.EndMonth.toString());
  //     formData.append("EndYear", this.SchemeModel.EndYear.toString());
  //     formData.append("Branch", this.SchemeModel.Branch);
  //     formData.append("SchemeType", this.SchemeModel.SchemeType);
  //     formData.append("SchemeFile", this.theFile);
  //     formData.append("UserEmail", this.UserEmail);

  //     this.schemeServices.UploadBulkScheme(formData).subscribe(
  //       data => {
  //         this.loading = false;
  //         var result = data;
  //         if (data.success) {
  //           this.Reset();
  //         }
  //         this.toastr.info('', data.message, { timeOut: 50000 });
  //       },
  //       error => {
  //         this.loading = false;
  //         console.log(error);
  //       }
  //     );
  //   }
  // }


}
